import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_ASSETS_PERIODS = '@periods/get-assets-periods';
export const REQUEST_ASSETS_PERIODS = '@periods/request-assets-periods';

export function getAssetsPeriods() {
  const request = axios.get(`${API_BASE_URL}/asset-period`);

  return (dispatch) => {
    dispatch({ type: REQUEST_ASSETS_PERIODS });

    request
      .then((response) =>
        dispatch({
          type: GET_ASSETS_PERIODS,
          payload: { assetsPeriods: response.data }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_ASSETS_PERIODS,
          payload: { assetsPeriods: [], message }
        });
      });
  };
}
